'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgMiscPackage = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", fillRule: "evenodd", d: "M21 9h1V3H2v6h17v9.996H5V11H3v9.996h18V9ZM4.222 5v2h15.556V5H4.222Z", clipRule: "evenodd" }),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M15 13H9v-2h6v2Z" })
);

module.exports = SvgMiscPackage;
//# sourceMappingURL=MiscPackage.cjs.js.map
